import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { BestaOpeningFunctionComponent } from '@inter-ikea-storageone/range-besta';
import { getRange } from 'utils/queryUtils';
import { getAllowedHandleTypes } from 'rangeConfig/shared/utils/frontLayouts';

const shouldRecommendHandles = (coreApi: CoreApi): boolean => {
  const handles = coreApi.entities.getByComponent(ComponentIds.HANDLE_COMPONENT_ID);
  const doors = coreApi.entities.getByComponent(ComponentIds.DOOR_COMPONENT_ID);
  const doorFronts = coreApi.entities.getByComponent(ComponentIds.DOOR_FRONT_COMPONENT_ID);

  const pushToOpenDrawersIds = coreApi.entities
    .getByComponent(ComponentIds.DRAWER_COMPONENT_ID)
    .filter(
      drawer =>
        drawer.getComponent<BestaOpeningFunctionComponent>(BestaOpeningFunctionComponent.id)
          ?.openingFunction === ProductType.BESTA_PUSH_OPEN
    )
    .flatMap(
      entity =>
        HierarchyUtils.findInHierarchy(entity, e =>
          e.hasComponent(ComponentIds.DOOR_FRONT_COMPONENT_ID)
        )?.id || []
    );

  const recommendHandlesEntities = (getRange() === 'besta' ? doorFronts : doors).filter(e => {
    if (pushToOpenDrawersIds.includes(e.id)) {
      return false;
    }
    return (
      getAllowedHandleTypes(e).includes(ProductType.HANDLE) ||
      getAllowedHandleTypes(e).includes(ProductType.KNOB) ||
      getAllowedHandleTypes(e).includes(ProductType.EDGE_HANDLE)
    );
  });

  return handles.length === 0 && recommendHandlesEntities.length > 0;
};

export default shouldRecommendHandles;
